import React from 'react';
import {Link} from "react-router-dom";
const NavBar = ()=>{

    return(
        <div className="Nav">
            <Link to="/home">Home</Link>
            <Link to="/signin">Sign In</Link>
            <Link to="/signup">Sign Up</Link>
            <Link to="/checkout">Checkout</Link>
        </div>
    );
}

export default NavBar;